/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: any } | undefined) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions || [];
  const hasPermission = (resource: string, scope: string) => true;
    /* permissions.some((p: any) => p.rsname === resource && p.scopes?.includes(scope)); */

  // Group-level access permissions - check if user has access to any child menu
  const hasAnyChildAccess = (childPermissions: string[]) => true;
    /* childPermissions.some(permission =>
      permissions.some((p: any) => p.rsname === permission && p.scopes?.includes('Read'))
    ); */

  return {
    // Group access permissions
    canViewMasterData: hasAnyChildAccess([
      'Brand',
      'Color',
      'Currency',
      'Origin',
      'Size',
      'KnitStructure',
      'Gauge',
      'NeedleType',
      'PatternType',
      'CamType',
      'MachineDiameter',
      'Uom',
      'Site',
      'AccountGroup',
    ]),
    canViewOrganizationGroup: hasAnyChildAccess(['Organization', 'OrganizationDetail', 'Address', 'AddressDetail']),
    canViewProduction: hasAnyChildAccess(['Line', 'Machine', 'MachineType', 'OperationLibrary', 'OperationLibraryDetail', 'Component', 'ComponentGroup']),
    canViewBusinessPartners: hasAnyChildAccess(['Customer', 'CustomerType', 'Supplier', 'SupplierType']),
    canViewProductManagement: hasAnyChildAccess(['Product', 'Category', 'ProductGroup', 'SubCategory']),
    canViewHumanResources: hasAnyChildAccess(['Employee', 'EmployeeType', 'Calendar', 'CalendarCustomize', 'Holiday']),
    canViewShippingLogistics: hasAnyChildAccess(['Port', 'DeliveryTerm', 'ShipmentTerm', 'PaymentTerm']),
    canViewIEAnalysis: hasAnyChildAccess(['IERequest', 'KnitAnalysis']),
    canViewLabDipAnalysis: hasAnyChildAccess(['LabDipRequest']),
    canViewWovenAnalysis: hasAnyChildAccess(['WovenRequest']),
    canViewDyeingAnalysis: hasAnyChildAccess(['DyeingRequest', 'Recipe', 'BeakerTest']),

    // Individual page access permissions
    canViewOrganization: hasPermission('Organization', 'Read'),
    canCreateOrganization: hasPermission('Organization', 'Create'),
    canUpdateOrganization: hasPermission('Organization', 'Update'),
    canDeleteOrganization: hasPermission('Organization', 'Delete'),

    canViewOrganizationDetail: hasPermission('OrganizationDetail', 'Read'),
    canCreateOrganizationDetail: hasPermission('OrganizationDetail', 'Create'),
    canUpdateOrganizationDetail: hasPermission('OrganizationDetail', 'Update'),
    canDeleteOrganizationDetail: hasPermission('OrganizationDetail', 'Delete'),

    canViewOperationLibraryDetail: hasPermission('OperationLibraryDetail', 'Read'),
    canViewAddressDetail: hasPermission('AddressDetail', 'Read'),

    canViewAccountGroup: hasPermission('AccountGroup', 'Read'),
    canCreateAccountGroup: hasPermission('AccountGroup', 'Create'),
    canUpdateAccountGroup: hasPermission('AccountGroup', 'Update'),
    canDeleteAccountGroup: hasPermission('AccountGroup', 'Delete'),

    canViewBrand: hasPermission('Brand', 'Read'),
    canCreateBrand: hasPermission('Brand', 'Create'),
    canUpdateBrand: hasPermission('Brand', 'Update'),
    canDeleteBrand: hasPermission('Brand', 'Delete'),

    canViewColor: hasPermission('Color', 'Read'),
    canCreateColor: hasPermission('Color', 'Create'),
    canUpdateColor: hasPermission('Color', 'Update'),
    canDeleteColor: hasPermission('Color', 'Delete'),

    canViewCurrency: hasPermission('Currency', 'Read'),
    canCreateCurrency: hasPermission('Currency', 'Create'),
    canUpdateCurrency: hasPermission('Currency', 'Update'),
    canDeleteCurrency: hasPermission('Currency', 'Delete'),

    canViewCustomer: hasPermission('Customer', 'Read'),
    canCreateCustomer: hasPermission('Customer', 'Create'),
    canUpdateCustomer: hasPermission('Customer', 'Update'),
    canDeleteCustomer: hasPermission('Customer', 'Delete'),

    canViewCustomerType: hasPermission('CustomerType', 'Read'),
    canCreateCustomerType: hasPermission('CustomerType', 'Create'),
    canUpdateCustomerType: hasPermission('CustomerType', 'Update'),
    canDeleteCustomerType: hasPermission('CustomerType', 'Delete'),

    canViewAddress: hasPermission('Address', 'Read'),
    canCreateAddress: hasPermission('Address', 'Create'),
    canUpdateAddress: hasPermission('Address', 'Update'),
    canDeleteAddress: hasPermission('Address', 'Delete'),

    canViewCalendarCustomize: hasPermission('CalendarCustomize', 'Read'),
    canCreateCalendarCustomize: hasPermission('CalendarCustomize', 'Create'),
    canUpdateCalendarCustomize: hasPermission('CalendarCustomize', 'Update'),
    canDeleteCalendarCustomize: hasPermission('CalendarCustomize', 'Delete'),

    canViewCalendar: hasPermission('Calendar', 'Read'),
    canCreateCalendar: hasPermission('Calendar', 'Create'),
    canUpdateCalendar: hasPermission('Calendar', 'Update'),
    canDeleteCalendar: hasPermission('Calendar', 'Delete'),

    canViewDeliveryTerm: hasPermission('DeliveryTerm', 'Read'),
    canCreateDeliveryTerm: hasPermission('DeliveryTerm', 'Create'),
    canUpdateDeliveryTerm: hasPermission('DeliveryTerm', 'Update'),
    canDeleteDeliveryTerm: hasPermission('DeliveryTerm', 'Delete'),

    canViewEmployee: hasPermission('Employee', 'Read'),
    canCreateEmployee: hasPermission('Employee', 'Create'),
    canUpdateEmployee: hasPermission('Employee', 'Update'),
    canDeleteEmployee: hasPermission('Employee', 'Delete'),

    // Added missing page permissions
    canViewEmployeeType: hasPermission('EmployeeType', 'Read'),
    canCreateEmployeeType: hasPermission('EmployeeType', 'Create'),
    canUpdateEmployeeType: hasPermission('EmployeeType', 'Update'),
    canDeleteEmployeeType: hasPermission('EmployeeType', 'Delete'),

    canViewHoliday: hasPermission('Holiday', 'Read'),
    canCreateHoliday: hasPermission('Holiday', 'Create'),
    canUpdateHoliday: hasPermission('Holiday', 'Update'),
    canDeleteHoliday: hasPermission('Holiday', 'Delete'),

    canViewLine: hasPermission('Line', 'Read'),
    canCreateLine: hasPermission('Line', 'Create'),
    canUpdateLine: hasPermission('Line', 'Update'),
    canDeleteLine: hasPermission('Line', 'Delete'),

    canViewMachine: hasPermission('Machine', 'Read'),
    canCreateMachine: hasPermission('Machine', 'Create'),
    canUpdateMachine: hasPermission('Machine', 'Update'),
    canDeleteMachine: hasPermission('Machine', 'Delete'),

    canViewMachineType: hasPermission('MachineType', 'Read'),
    canCreateMachineType: hasPermission('MachineType', 'Create'),
    canUpdateMachineType: hasPermission('MachineType', 'Update'),
    canDeleteMachineType: hasPermission('MachineType', 'Delete'),

    canViewOperationLibrary: hasPermission('OperationLibrary', 'Read'),
    canCreateOperationLibrary: hasPermission('OperationLibrary', 'Create'),
    canUpdateOperationLibrary: hasPermission('OperationLibrary', 'Update'),
    canDeleteOperationLibrary: hasPermission('OperationLibrary', 'Delete'),

    canViewOrigin: hasPermission('Origin', 'Read'),
    canCreateOrigin: hasPermission('Origin', 'Create'),
    canUpdateOrigin: hasPermission('Origin', 'Update'),
    canDeleteOrigin: hasPermission('Origin', 'Delete'),

    canViewPaymentTerm: hasPermission('PaymentTerm', 'Read'),
    canCreatePaymentTerm: hasPermission('PaymentTerm', 'Create'),
    canUpdatePaymentTerm: hasPermission('PaymentTerm', 'Update'),
    canDeletePaymentTerm: hasPermission('PaymentTerm', 'Delete'),

    canViewPort: hasPermission('Port', 'Read'),
    canCreatePort: hasPermission('Port', 'Create'),
    canUpdatePort: hasPermission('Port', 'Update'),
    canDeletePort: hasPermission('Port', 'Delete'),

    canViewProduct: hasPermission('Product', 'Read'),
    canCreateProduct: hasPermission('Product', 'Create'),
    canUpdateProduct: hasPermission('Product', 'Update'),
    canDeleteProduct: hasPermission('Product', 'Delete'),

    canViewShipmentTerm: hasPermission('ShipmentTerm', 'Read'),
    canCreateShipmentTerm: hasPermission('ShipmentTerm', 'Create'),
    canUpdateShipmentTerm: hasPermission('ShipmentTerm', 'Update'),
    canDeleteShipmentTerm: hasPermission('ShipmentTerm', 'Delete'),

    canViewSite: hasPermission('Site', 'Read'),
    canCreateSite: hasPermission('Site', 'Create'),
    canUpdateSite: hasPermission('Site', 'Update'),
    canDeleteSite: hasPermission('Site', 'Delete'),

    canViewSize: hasPermission('Size', 'Read'),
    canCreateSize: hasPermission('Size', 'Create'),
    canUpdateSize: hasPermission('Size', 'Update'),
    canDeleteSize: hasPermission('Size', 'Delete'),

    canViewSupplier: hasPermission('Supplier', 'Read'),
    canCreateSupplier: hasPermission('Supplier', 'Create'),
    canUpdateSupplier: hasPermission('Supplier', 'Update'),
    canDeleteSupplier: hasPermission('Supplier', 'Delete'),

    canViewSupplierType: hasPermission('SupplierType', 'Read'),
    canCreateSupplierType: hasPermission('SupplierType', 'Create'),
    canUpdateSupplierType: hasPermission('SupplierType', 'Update'),
    canDeleteSupplierType: hasPermission('SupplierType', 'Delete'),

    canViewUom: hasPermission('Uom', 'Read'),
    canCreateUom: hasPermission('Uom', 'Create'),
    canUpdateUom: hasPermission('Uom', 'Update'),
    canDeleteUom: hasPermission('Uom', 'Delete'),

    // JobPosition permissions
    canViewJobPosition: hasPermission('JobPosition', 'Read'),
    canCreateJobPosition: hasPermission('JobPosition', 'Create'),
    canUpdateJobPosition: hasPermission('JobPosition', 'Update'),
    canDeleteJobPosition: hasPermission('JobPosition', 'Delete'),

    // Category permissions
    canViewCategory: hasPermission('Category', 'Read'),
    canCreateCategory: hasPermission('Category', 'Create'),
    canUpdateCategory: hasPermission('Category', 'Update'),
    canDeleteCategory: hasPermission('Category', 'Delete'),

    // ProductGroup permissions
    canViewProductGroup: hasPermission('ProductGroup', 'Read'),
    canCreateProductGroup: hasPermission('ProductGroup', 'Create'),
    canUpdateProductGroup: hasPermission('ProductGroup', 'Update'),
    canDeleteProductGroup: hasPermission('ProductGroup', 'Delete'),

    // SubCategory permissions
    canViewSubCategory: hasPermission('SubCategory', 'Read'),
    canCreateSubCategory: hasPermission('SubCategory', 'Create'),
    canUpdateSubCategory: hasPermission('SubCategory', 'Update'),
    canDeleteSubCategory: hasPermission('SubCategory', 'Delete'),

    // Component permissions
    canViewComponent: hasPermission('Component', 'Read'),
    canCreateComponent: hasPermission('Component', 'Create'),
    canUpdateComponent: hasPermission('Component', 'Update'),
    canDeleteComponent: hasPermission('Component', 'Delete'),

    // IERequest permissions
    canViewIERequest: hasPermission('IERequest', 'Read'),
    canCreateIERequest: hasPermission('IERequest', 'Create'),
    canUpdateIERequest: hasPermission('IERequest', 'Update'),
    canDeleteIERequest: hasPermission('IERequest', 'Delete'),
    canSubmitIERequest: hasPermission('IERequest', 'Submit'),
    canCancelIERequest: hasPermission('IERequest', 'Cancel'),

    // KnitAnalysis permissions
    canViewKnitAnalysis: hasPermission('KnitAnalysis', 'Read'),
    canCreateKnitAnalysis: hasPermission('KnitAnalysis', 'Create'),
    canUpdateKnitAnalysis: hasPermission('KnitAnalysis', 'Update'),
    canDeleteKnitAnalysis: hasPermission('KnitAnalysis', 'Delete'),
    canSubmitKnitAnalysis: hasPermission('KnitAnalysis', 'Submit'),
    canCancelKnitAnalysis: hasPermission('KnitAnalysis', 'Cancel'),
    canStartKnitAnalysis: hasPermission('KnitAnalysis', 'Start'),
    canApproveKnitAnalysis: hasPermission('KnitAnalysis', 'Approve'),
    canRejectKnitAnalysis: hasPermission('KnitAnalysis', 'Reject'),

    // LabDipRequest permissions
    canViewLabDipRequest: hasPermission('LabDipRequest', 'Read'),
    canCreateLabDipRequest: hasPermission('LabDipRequest', 'Create'),
    canUpdateLabDipRequest: hasPermission('LabDipRequest', 'Update'),
    canDeleteLabDipRequest: hasPermission('LabDipRequest', 'Delete'),
    canSubmitLabDipRequest: hasPermission('LabDipRequest', 'Submit'),
    canCancelLabDipRequest: hasPermission('LabDipRequest', 'Cancel'),

    // WovenRequest permissions
    canViewWovenRequest: hasPermission('WovenRequest', 'Read'),
    canCreateWovenRequest: hasPermission('WovenRequest', 'Create'),
    canUpdateWovenRequest: hasPermission('WovenRequest', 'Update'),
    canDeleteWovenRequest: hasPermission('WovenRequest', 'Delete'),
    canSubmitWovenRequest: hasPermission('WovenRequest', 'Submit'),
    canCancelWovenRequest: hasPermission('WovenRequest', 'Cancel'),

    // DyeingRequest permissions
    canViewDyeingRequest: hasPermission('DyeingRequest', 'Read'),
    canCreateDyeingRequest: hasPermission('DyeingRequest', 'Create'),
    canUpdateDyeingRequest: hasPermission('DyeingRequest', 'Update'),
    canDeleteDyeingRequest: hasPermission('DyeingRequest', 'Delete'),
    canSubmitDyeingRequest: hasPermission('DyeingRequest', 'Submit'),
    canCancelDyeingRequest: hasPermission('DyeingRequest', 'Cancel'),

    // Recipe permissions
    canViewRecipe: hasPermission('Recipe', 'Read'),
    canCreateRecipe: hasPermission('Recipe', 'Create'),
    canUpdateRecipe: hasPermission('Recipe', 'Update'),
    canCancelRecipe: hasPermission('Recipe', 'Cancel'),
    canReviseRecipe: hasPermission('Recipe', 'Revise'),

    // BeakerTest permissions
    canViewBeakerTest: hasPermission('BeakerTest', 'Read'),
    canUpdateBeakerTest: hasPermission('BeakerTest', 'Update'),

    // ComponentGroup permissions
    canViewComponentGroup: hasPermission('ComponentGroup', 'Read'),
    canCreateComponentGroup: hasPermission('ComponentGroup', 'Create'),
    canUpdateComponentGroup: hasPermission('ComponentGroup', 'Update'),
    canDeleteComponentGroup: hasPermission('ComponentGroup', 'Delete'),

    // KnitStructure permissions
    canViewKnitStructure: hasPermission('KnitStructure', 'Read'),
    canCreateKnitStructure: hasPermission('KnitStructure', 'Create'),
    canUpdateKnitStructure: hasPermission('KnitStructure', 'Update'),
    canDeleteKnitStructure: hasPermission('KnitStructure', 'Delete'),

    // Gauge permissions
    canViewGauge: hasPermission('Gauge', 'Read'),
    canCreateGauge: hasPermission('Gauge', 'Create'),
    canUpdateGauge: hasPermission('Gauge', 'Update'),
    canDeleteGauge: hasPermission('Gauge', 'Delete'),

    // NeedleType permissions
    canViewNeedleType: hasPermission('NeedleType', 'Read'),
    canCreateNeedleType: hasPermission('NeedleType', 'Create'),
    canUpdateNeedleType: hasPermission('NeedleType', 'Update'),
    canDeleteNeedleType: hasPermission('NeedleType', 'Delete'),

    // PatternType permissions
    canViewPatternType: hasPermission('PatternType', 'Read'),
    canCreatePatternType: hasPermission('PatternType', 'Create'),
    canUpdatePatternType: hasPermission('PatternType', 'Update'),
    canDeletePatternType: hasPermission('PatternType', 'Delete'),

    // CamType permissions
    canViewCamType: hasPermission('CamType', 'Read'),
    canCreateCamType: hasPermission('CamType', 'Create'),
    canUpdateCamType: hasPermission('CamType', 'Update'),
    canDeleteCamType: hasPermission('CamType', 'Delete'),

    // MachineDiameter permissions
    canViewMachineDiameter: hasPermission('MachineDiameter', 'Read'),
    canCreateMachineDiameter: hasPermission('MachineDiameter', 'Create'),
    canUpdateMachineDiameter: hasPermission('MachineDiameter', 'Update'),
    canDeleteMachineDiameter: hasPermission('MachineDiameter', 'Delete'),
  };
}
